import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgArrowRightCircle(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsx("path", {
        className: "arrow-right-circle_svg__fillPath",
        d: "M20 10c0 5.523-4.477 10-10 10a10 10 0 1110-10zM8 16l6-6-6-6-1.4 1.4 4.6 4.6-4.6 4.6L8 16z",
        fill: "#0D5A6D",
        fillRule: "evenodd"
      })
    })
  }));
}

export { SvgArrowRightCircle as default };
